import React from 'react';
import { Fab, IconButton } from '@material-ui/core';
import FacebookCircularProgress from './FacebookCircularProgress';
import { 
            GetApp as GetAppIcon     
} from '@material-ui/icons';
import { Page, Text, View, Document, StyleSheet, Image as ImagePdf, Font, usePDF } from '@react-pdf/renderer';

const PdfElementInvoice = ({data, HandleClickPdf, InfoEmpresa, isSmall})=>{

    console.log(__dirname)

    Font.register({family: 'Oswald',src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'});

    const styles = StyleSheet.create({
        container:{
            width:'100vw', 
            height:'100vh',
            margin:'0px auto',
            display:'flex',
            justifyContent:'flex-start',
            alignContent:'flex-start',
            alignItems:'flex-start',
            padding:'30px 50px',
        },
        header1:{
            borderWidth:1,
            borderStyle:'solid',
            borderColor:'gray',
            width:'100%',
            height:110,
            alignSelf: 'flex-start',
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            margin:0,
        },
        header2:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            width:'100%',
            height:75,
            alignSelf: 'flex-start',
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            marginTop:-1
        },
        subheader1_1:{
            width:'30%',
            height:'100%',
            padding:5,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            alignItems:'center'
        },
        subheader1_2:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            width:'70%',
            height:'100%',
        },
        subheader2_1:{
            width:'50%',
            height:'100%',
            padding:5
        },
        subheader2_2:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            width:'50%',
            height:'100%',
            paddingTop:5
        },
        image: {
            objectFit:'container',
            height:'100%',
        },
        pPadre:{
            fontSize: 16,
            textAlign: 'center',
            color:'#1a237e',
            fontWeight: 'extrabold',
            margin:2,
        },
        pHijos:{
            fontWeight: 'extrabold',
            margin:2,
            fontSize: 9,
            color:'#000'
        },
        pHijos2:{
            fontWeight: 'extrabold',
            margin:5,
            fontSize: 9,
            color:'#000'
        },
        logoSpan:{  
            width:12,
            height:12,
            marginTop:2,
            marginRight:3,
        },
        viewText:{
            display:'flex',
            flexDirection:'row',
            height:20,
            paddingLeft:5
        },
        Nombres:{
            margin:2,
            fontSize: 9,
            color:'#000',
            paddingLeft:5
        },
        NombresT:{
            margin:2,
            fontSize: 9,
            color:'#000',
            paddingLeft:5,
            textAlign:'right'
        },
        Nombres2:{
            margin:2,
            fontSize: 7,
            color:'#000',
        },
        Nombres22:{
            margin:'-8px 2px 2px 2px',
            fontSize: 7,
            color:'#000',
        },
        tableHead:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            width:'100%',
            height:30,
            alignSelf: 'flex-start',
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            marginTop:-1
        },
        tableHead2:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            width:'100%',
            height:50,
            alignSelf: 'flex-start',
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            marginTop:-1
        },
        tableHead_1:{
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'15%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        tableHead_2:{
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'40%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        tableHead_22:{
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'40%',
            height:'100%',
            textAlign:'left',
            padding:1
        },
        tableHead_3:{
            width:'15%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        tableHead_4:{
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'55%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        tableHead_5:{
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'30%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        tableHead_6:{
            width:'15%',
            height:'100%',
            textAlign:'left',
            padding:5
        },
        footer:{
            textAlign:'left',
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            width:'100%',
            height:80,
            padding:20
        }
    });

    const MyDoc = (
        <Document>
            <Page size="A4" orientation="portrait" wrap>
                <View style={styles.container} wrap>
                    <View style={styles.header1}>
                        <View style={styles.subheader1_1}>
                            <ImagePdf source={InfoEmpresa.urlLogoFactura} style={styles.image} />
                        </View>
                        <View style={styles.subheader1_2}>
                            <Text style={styles.pPadre}>{InfoEmpresa.Empresa}</Text>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/ubicacion.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}> { InfoEmpresa.Direccion }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/whatsapp.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.Telefono }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/mail.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.EmailInfo }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/web.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.PaginaWeb }</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.header2}>
                        <View style={styles.subheader2_1}>
                            <Text style={styles.pHijos}> CLIENTE:</Text>
                            <Text style={styles.Nombres}> {data.Nombres}</Text>
                            <Text style={styles.pHijos}> FORMA DE PAGO: {data.TipoPago}</Text>
                        </View>
                        <View style={styles.subheader2_2}>
                            <Text style={styles.pHijos}> FACTURA: {data.NumberInvoice}</Text>
                            <Text style={styles.pHijos}> FECHA DE PAGO: {data.FechaPago.split('T')[0]}</Text>
                            <Text style={styles.pHijos}> FECHA DE VENCIMIENTO DE PAGO: {data.fechaCorte}</Text>
                            <Text style={styles.pHijos}> ESTADO: {data.Status}</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.pHijos}> ITEM</Text>
                        </View>
                        <View style={styles.tableHead_2}>
                            <Text style={styles.pHijos}> DESCRIPCION</Text>
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.pHijos}> CANT.</Text>
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.pHijos}> PRECIO</Text>
                        </View>
                        <View style={styles.tableHead_3}>
                            <Text style={styles.pHijos}> TOTAL</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead2}>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.Nombres}> 1</Text>
                        </View>
                        <View style={styles.tableHead_22}>
                            <Text style={styles.Nombres2}> { 
                           `Plan de Internet: ${data.PlanComercial} $${data.ValPlan} Correspondiente al Mes de ${data.MesServicio}
                            `}
                            </Text>
                            {
                                data.isDetalleManual ?
                                <Text style={styles.Nombres22} > 
                                    { data.detalleManual }
                                </Text> : null
                            }
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.Nombres}> 1</Text>
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.NombresT}>${parseFloat( data.isDetalleManual ? data.valorManual : data.ValPlan ).toFixed(2)}</Text>
                        </View>
                        <View style={styles.tableHead_3}>
                            <Text style={styles.NombresT}>${parseFloat( data.isDetalleManual ? data.valorManual : data.ValPlan ).toFixed(2)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead2}>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.Nombres}>{ data.isAdicional ? 2 : '' }</Text>
                        </View>
                        <View style={styles.tableHead_22}>
                            <Text style={styles.Nombres2}> 
                            { data.isAdicional ? data.DetalleAdicional : '' }
                            </Text>
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.Nombres}>{ data.isAdicional ? 1 : '' }</Text>
                        </View>
                        <View style={styles.tableHead_1}>
                            <Text style={styles.NombresT}>{ data.isAdicional ? '$' : '' }{ data.isAdicional ? data.valAdicional : '' }</Text>
                        </View>
                        <View style={styles.tableHead_3}>
                            <Text style={styles.NombresT}>{ data.isAdicional ? '$' : '' }{ data.isAdicional ? data.valAdicional : '' }</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_4}>
                            
                        </View>
                        <View style={styles.tableHead_5}>
                            <Text style={styles.pHijos}> SUBTOTAL
                            </Text>
                        </View>
                        <View style={styles.tableHead_6}>
                            <Text style={styles.NombresT}> ${data.subTotal}</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_4}>
                            
                        </View>
                        <View style={styles.tableHead_5}>
                            <Text style={styles.pHijos}> DESCUENTO
                            </Text>
                        </View>
                        <View style={styles.tableHead_6}>
                            <Text style={styles.NombresT}>${ parseFloat(data.valDescuento).toFixed(2) }</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_4}>
                            
                        </View>
                        <View style={styles.tableHead_5}>
                            <Text style={styles.pHijos}> IVA
                            </Text>
                        </View>
                        <View style={styles.tableHead_6}>
                            <Text style={styles.NombresT}>${ data.IVA ? data.ValIvaFixed : '0.00' }</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_4}>
                            
                        </View>
                        <View style={styles.tableHead_5}>
                            <Text style={styles.pHijos}> SALDO PENDIENTE
                            </Text>
                        </View>
                        <View style={styles.tableHead_6}>
                            <Text style={styles.NombresT}> $0.00</Text>
                        </View>
                    </View>
                    <View style={styles.tableHead}>
                        <View style={styles.tableHead_4}>
                            
                        </View>
                        <View style={styles.tableHead_5}>
                            <Text style={styles.pHijos}> GRAND TOTAL
                            </Text>
                        </View>
                        <View style={styles.tableHead_6}>
                            <Text style={styles.NombresT}> ${data.IVA ? data.ValPlanIVA : data.ValTotal}</Text>
                        </View>
                    </View>
                    <View style={styles.footer}>
                        <Text style={styles.pHijos2}> FORMAS DE PAGO: </Text>
                        {
                            InfoEmpresa.Bancos.map(el=>
                                <React.Fragment key={el._id}>
                                    <Text style={styles.pHijos2}>
                                        &nbsp;&nbsp;- {el.Banco} CTA. {el.Tipo} {el.Cuenta}
                                    </Text>
                                </React.Fragment>
                            )
                        }
                        
                        <View style={{textAlign: 'center', width:'100%', marginTop:5}}>
                            <Text style={styles.pHijos}>
                                MUCHAS GRACIAS POR SU PAGO!
                            </Text>
                        </View>
                        
                    </View>
                </View>
            </Page>
        </Document>
    );

    const [ instance ] = usePDF({ document: MyDoc });

    if (instance.loading) return <FacebookCircularProgress size={isSmall ? 20 : 30} style={{marginTop:5}} />;

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;

    if(isSmall){
        return (
            <IconButton 
                color='primary' 
                href={instance.url} 
                onClick={HandleClickPdf} 
                size='small' 
                style={{ backgroundColor:'#fff' }}
                target='_blank' 
                >
                <GetAppIcon />
            </IconButton>
        );
    }else{
        return (
            <Fab href={instance.url} onClick={HandleClickPdf} size='small' color='primary' target='_blank'>
                <GetAppIcon />
            </Fab>
        );
    }

};

export default PdfElementInvoice;